import { useGeolocation } from '@portals/core/src/hooks/useGeolocation';
import axios from 'axios';
import { useCallback, useState } from 'react';

export interface Bank {
  bankCode: string;
  name: string;
}

interface Result {
  banks: Bank[];
  getBanks: () => Promise<Bank[]>;
  loading: boolean;
}

export const useBankFromGeolocation = (): Result => {
  const [bankObjects, setBankObjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const { fetch } = useGeolocation();

  const onGetBanks = useCallback(() => {
    setLoading(true);
    return fetch()
      .then(async (value) => {
        const getObjects = async () => {
          const { data } = await axios.get(process.env.FILIALFINDER_API_ENDPOINT, {
            params: {
              func: 'get_objects',
              blz: 90090090,
              latitude: value.latitude,
              longitude: value.longitude,
              query: 'excludeBlz=9,60050101',
            },
          });

          if (data.error) {
            throw data.error;
          }

          return data.fifiObject;
        };

        const fifiObjects = await getObjects();
        const seenBankCodes = new Set();

        const result = fifiObjects.reduce((accumulator: Bank[], current: { blz: string; spkName: string }) => {
          if (seenBankCodes.has(current.blz)) {
            return accumulator;
          }

          accumulator.push({ bankCode: `${current.blz}`, name: `${current.spkName}` });
          seenBankCodes.add(current.blz);

          return accumulator;
        }, []);

        setBankObjects(result);
        setLoading(false);
        return result;
      })
      .finally(() => setLoading(false));
  }, [fetch]);

  return {
    banks: bankObjects,
    getBanks: onGetBanks,
    loading,
  };
};
